import {get} from './walletAxios';
import {UserProfileDto, UserStatsRecordDto} from "../app/types/user";

export const PROFILE_PATH = '/api/user';

export const getCurrentUserProfile = async (): Promise<UserProfileDto> => {
    return get(`${PROFILE_PATH}/profile`).then(response => response ?? {});
};

export const findTop20ByAvgGamePoints = async (): Promise<UserStatsRecordDto[]> => {
    return get(`${PROFILE_PATH}/stats/avg`).then(response => response ?? {});
};

export const findTop20ByGamesPlayed = async (): Promise<UserStatsRecordDto[]> => {
    return get(`${PROFILE_PATH}/stats/games`).then(response => response ?? {});
};

export const findTop20ByGamesWon = async (): Promise<UserStatsRecordDto[]> => {
    return get(`${PROFILE_PATH}/stats/games-won`).then(response => response ?? {});
};
